import React from "react";
import ProductBox, { ProductBoxProps } from "@/src/components/ProductBox/ProductBox";

export type HintBoxProps = { headline: Required<ProductBoxProps["headline"]> } & ProductBoxProps;

// TODO: In long run replace with product box
export default function HintBox({ variant = "hintbox", headline, ...productBoxProps }: HintBoxProps) {
  return <ProductBox {...productBoxProps} variant={variant} headline={<strong>{headline}</strong>} />;
}
